import { colors } from 'app/theme/colors'
import artImage from 'assets/images/art.svg'
import commerceImage from 'assets/images/commerce.svg'
import danceImage from 'assets/images/dance.svg'
import fitnessImage from 'assets/images/fitness.svg'
import karateImage from 'assets/images/karate.svg'
import scienceImage from 'assets/images/science.svg'
import theatreImage from 'assets/images/theatre.svg'
import vocalsImage from 'assets/images/vocals.svg'

export const scheduleColors = [
  colors.ohTeal, //green
  colors.ohRed, //red
  '#58B7E6', //blue
  colors.ohYellow, //yellow
  '#58B7E6', //blue
  colors.ohYellow, //yellow
  colors.ohTeal, //green
  colors.ohRed, //red
  colors.ohYellow, //yellow
  colors.ohTeal, //green
  colors.ohRed, //red
  '#58B7E6', //blue
  colors.ohYellow, //yellow
  '#58B7E6', //blue
  colors.ohRed //red
]

export const subjectsList = [
  { name: 'art', image: artImage },
  { name: 'dance', image: danceImage },
  { name: 'karate', image: karateImage },
  { name: 'vocals', image: vocalsImage },
  { name: 'commerce', image: commerceImage },
  { name: 'science', image: scienceImage },
  { name: 'fitness', image: fitnessImage },
  { name: 'theatre', image: theatreImage }
]

export const batchTypesColorList = {
  class: colors.ohOrange, //orange
  event: '#58B7E6', //blue
  exploration: colors.ohYellow, //yellow
  explore: colors.ohTeal, //green
  membership: colors.ohOrange, //orange
  exploration_camp: '#E9C9E1', //lavender
  disabled: 'rgba(0, 0, 0, 0.36)'
}

export const dataColumns = {
  attendance: {
    type: 'ATTENDANCE',
    heading: 'Attendance',
    tableHeadings: [
      { label: 'Student', type: 'text' },
      { label: 'Attendance', type: 'checkbox' }
    ],
    accessors: ['student', 'attended']
  },
  // Consumed via the computed key `dataColumns[attendanceType[attendanceDay]]`
  // in components/SliderCard.js — a grep for 'futureAttendance' will not find
  // the call site. Deleting this entry blanks the drawer on upcoming dates.
  futureAttendance: {
    type: 'FUTURE_ATTENDANCE',
    heading: 'Attendance',
    tableHeadings: [
      { label: 'Student', type: 'text' },
      { label: 'Parent Name', type: 'text' },
      { label: 'Parent Number', type: 'text' }
    ],
    accessors: ['student', 'parent_name', 'parent_number']
  },
  student: {
    type: 'STUDENT_ATTENDANCE',
    heading: 'Attendance',
    tableHeadings: [
      { label: 'Course', type: 'text' },
      { label: 'Timings', type: 'text' },
      { label: 'Teacher', type: 'text' },
      { label: 'Attendance', type: 'checkbox' }
    ],
    accessors: ['course', 'timings', 'teacher', 'attended']
  },
  futureStudent: {
    type: 'FUTURE_STUDENT_ATTENDANCE',
    heading: 'Attendance',
    tableHeadings: [
      { label: 'Course', type: 'text' },
      { label: 'Timings', type: 'text' },
      { label: 'Teacher', type: 'text' }
    ],
    accessors: ['course', 'timings', 'teacher']
  }
}

export const emptyStudent = {
  full_name: '',
  phone_number: '',
  uuid: '',
  parent_id: '',
  student_id: '',
  attendances: []
}

export const attendanceType = {
  past: 'pastAttendance',
  future: 'futureAttendance',
  present: 'attendance'
}

export const studentType = {
  past: 'student',
  future: 'futureStudent',
  present: 'student'
}

export const filterPillList = [
  {
    displayName: 'Active Classes',
    name: 'enrolments',
    key: 'enrolments'
  },
  {
    displayName: 'Cancelled classes/ Classes with 0 Students',
    name: 'cancelledOrZero',
    key: 'cancelledOrZero'
  }
]
